export default "__VITE_ASSET__Ckz5_xce__";